export default __webpack_public_path__ + "static/media/placeholder.0eb7c2ba.png";